import { type TransferShiftQuizQuestion } from "./QuizQuestionCard";

export const namePlaceholder = "{name}";

export function replaceNames(
  quizQuestion: TransferShiftQuizQuestion,
  name: string
): TransferShiftQuizQuestion {
  function stringReplaceName(string: string, name: string) {
    return string.replaceAll(namePlaceholder, name);
  }

  return {
    question: stringReplaceName(quizQuestion.question, name),
    correctAnswer: stringReplaceName(quizQuestion.correctAnswer, name),
    wrongAnswers: quizQuestion.wrongAnswers.map((wrongAnswer) =>
      stringReplaceName(wrongAnswer, name)
    ),
    onWrongMessage: stringReplaceName(quizQuestion.onWrongMessage, name),
    onCorrectMessage: stringReplaceName(quizQuestion.onCorrectMessage, name),
  };
}
